import { searchBoxClassNames } from '@fluentui/react-components';
import i18n from 'i18next';
import { relative } from 'path';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    load: 'languageOnly',
    fallbackLng: {
      'zh-Hans': ['zh'],
      'zh-Hans-CN': ['zh'],
      'zh-CN': ['zh'],
      'default': ['en'],
    },
    supportedLngs: ['en', 'zh'],
    nonExplicitSupportedLngs: true,
    resources: {
      en: {
        translation: {
          description: 'Description',
          current_locale: 'en-us',
          str_heading: 'Microsoft Store Parser',
          header_msdc_title: 'Try our new product!',
          header_msdc_name: 'MSDocsCHS',
          header_msdc_desc: 'provides human-reviewed Chinese (Simp.) translations of Microsoft documentation.',
          search_item_label_product_id: 'Product ID',
          search_item_label_product_id_example: 'Like 9pm860492szd, no case sensitive.',
          search_item_label_mkt: 'Market',
          search_item_label_mkt_example: 'Like US, no case sensitive.',
          search_item_label_locale: 'Locale',
          search_item_label_locale_example: 'Like en-us, no case sensitive. Default will be used if not provided.',
          search: 'Search',
          view_in_ms_store: 'View in Microsoft Store',
          download_installer: 'Download Installer',
          download_tooltip: 'Once downloaded and opened, please follow the on-screen instructions to complete the installation.',
          configuration_last_updated_at: 'Configuration last updated at',
          supported_languages: 'Supported Languages',
          self_hosted_notification: 'This app is provided and updated by the developer',
          config_from: 'from',
          age_rating: 'Age Rating',
          age_rating_system: 'Age Rating System',
          age_rating_value: 'Age Rating Value',
          platforms: 'Platforms',
          age_rating_not_applied_for_current_market: 'Age rating is not applied for the current product or market.',
          privacy_policy: 'Privacy Policy',
          video_instances: 'Video Instances',
          resolution_detail: 'Resolution Detail',
          resolution_format: 'Resolution Format',
          delivery_format: 'Delivery Format',
          size_in_gb: 'Size',
          video_duration: 'Duration: ',
          rating_descriptors: 'Rating Descriptors',
          rating_age: 'Rating Age',
          age_rating_restrictions: 'Restrictions',
          age_rating_restrictions_metadata: 'Restricted Metadata',
          age_rating_restrictions_purchase: 'Restricted Purchase',
          released: 'Released at',
          purchase_enabled_msg: 'This app indicates that it offers in-app purchases',
          downloadability: 'Downloadability',
          downloadable_for_current_market: 'This item is downloadable for the current market.',
          not_downloadable_for_current_market: 'This item is not downloadable for the current market.',
          hidden_from_downloads_and_updates: 'This item is hidden from downloads and updates.',
          subscription_badge: 'Subscription',
          unknown: 'Unknown',
          operating_system: 'Operating System',
          installer_type: 'Installer Type',
          installer_id: 'Installer ID',
          support_uri: 'Support URI',
          related_links: 'Related Links',
          is_private_preview_badge: 'Private Preview',
          release_notes: 'Release Notes',
          permissions_required: 'Permissions Required',
          pwa_app_badge: 'PWA',
          pwa_app_tooltip: 'This app is a Progressive Web App (PWA).',
          verified_microsoft_product: 'Verified Microsoft Product',
          verified_microsoft_product_tooltip: 'This product is from Microsoft.',
          edge_featured: 'Featured',
          edge_featured_tooltip: 'This extension follows all of Microsoft\'s recommended practices and has been verified.',
          users_count: 'Users',
          edge_addon_badge: 'Edge Add-on',
          edge_addon_tooltip: 'This app is a Microsoft Edge extension.',
          view_in_edge_addons: 'View in Edge Add-ons',
          rating_interactive_elements: 'Interactive Elements',
          view_in_xbox: 'View in Xbox Store',
          manage_cookies: 'Manage Cookies',
          close: 'Close',
        },
      },
      zh: { 
        translation: {
          description: '描述',
          current_locale: 'zh-cn',
          str_heading: 'Microsoft Store 解析器',
          header_msdc_title: '试试我们的新产品！',
          header_msdc_name: 'MSDocsCHS',
          header_msdc_desc: '提供微软文档的经人工审阅的中文（简体）翻译。',
          search_item_label_product_id: '产品 ID',
          search_item_label_product_id_example: '形如 9pm860492szd，不区分大小写。',
          search_item_label_mkt: '市场',
          search_item_label_mkt_example: '形如 CN，不区分大小写。',
          search_item_label_locale: '语言',
          search_item_label_locale_example: '形如 zh-cn，不区分大小写。若未提供，将使用默认值。',
          search: '搜索',
          view_in_ms_store: '在 Microsoft Store 中查看',
          download_installer: '下载安装程序',
          download_tooltip: '下载完成后并打开后，请遵循屏幕上的指引完成安装。',
          configuration_last_updated_at: '配置最后更新于',
          supported_languages: '支持的语言',
          self_hosted_notification: '此应用由其开发者提供和更新',
          config_from: '来自',
          age_rating: '年龄评级',
          age_rating_system: '年龄评级体系',
          age_rating_value: '年龄评级值',
          platforms: '平台',
          age_rating_not_applied_for_current_market: '当前产品或市场未应用年龄评级。',
          privacy_policy: '隐私政策',
          video_instances: '视频实例',
          resolution_detail: '分辨率详情',
          resolution_format: '分辨率格式',
          delivery_format: '分发格式',
          size_in_gb: '大小',
          video_duration: '时长：',
          rating_descriptors: '评级描述',
          rating_age: '评级年龄',
          age_rating_restrictions: '限制',
          age_rating_restrictions_metadata: '限制级元数据',
          age_rating_restrictions_purchase: '限制购买',
          released: '发布于',
          purchase_enabled_msg: '该应用标称其提供应用内购买项',
          downloadability: '可下载性',
          downloadable_for_current_market: '此项可在当前市场下载。',
          not_downloadable_for_current_market: '此项不可在当前市场下载。',
          hidden_from_downloads_and_updates: '此项已从下载和更新中隐藏。',
          subscription_badge: '订阅',
          unknown: '未知',
          operating_system: '操作系统',
          installer_type: '安装程序类型',
          installer_id: '安装程序 ID',
          support_uri: '支持链接',
          related_links: '相关链接',
          is_private_preview_badge: '内部预览',
          release_notes: '发版日志',
          permissions_required: '所需权限',
          pwa_app_badge: 'PWA',
          pwa_app_tooltip: '此应用为渐进式 Web 应用（PWA）。',
          verified_microsoft_product: '已验证的 Microsoft 产品',
          verified_microsoft_product_tooltip: '此产品来自 Microsoft。',
          edge_featured: '特别推荐',
          edge_featured_tooltip: '此扩展遵循 Microsoft 的所有推荐做法，并已验证。',
          users_count: '用户',
          edge_addon_badge: 'Edge 扩展',
          edge_addon_tooltip: '此应用为 Microsoft Edge 扩展。',
          view_in_edge_addons: '在 Edge Add-ons 中查看',
          rating_interactive_elements: '交互式元素',
          view_in_xbox: '在 Xbox Store 中查看',
          manage_cookies: '管理 Cookie',
          close: '关闭',
        },
      },
    }
  });

export default i18n;
